import * as React from "react";
import { CartSlider, Cart } from "@grandvisionhq/carts-v2";
import { Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { Consents } from "../../../../../Consents/layout/modules/Consents/layout/Consents.js";
/* empty css                       */
import { ShippingMethods } from "../../../../../../StepShipping/modules/ShippingMethods/layouts/StepShipping/modules/ShippingMethods/layouts/ShippingMethods.js";
import { ExpressCheckoutFormContainer } from "../../../ExpressCheckoutFormContainer/modules/ExpressCheckout/components/ExpressCheckoutFormContainer/ExpressCheckoutFormContainer.js";
import { ServiceStoreHeading } from "../../../../../ServiceStore/layout/modules/ServiceStore/layout/ServiceStoreHeading.js";
import { ServiceStore } from "../../../../../ServiceStore/layout/modules/ServiceStore/layout/ServiceStore.js";
import { ImplicitTermsAndConditionsContainer } from "../../../../../../StepShipping/containers/StepShipping/containers/ImplicitTermsAndConditionsContainer.js";
const ExpressCheckoutUI = ({
  shippingMethodsAsides,
  isNearestPickup
}) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      expressShipmentMethodTitle: getLabel("checkout.express.shipment.method.title"),
      expressServiceStoreTitle: getLabel("checkout.express.serviceStore.title"),
      expressServiceStoreSubtitle: getLabel("checkout.express.serviceStore.subtitle")
    }),
    [getLabel]
  );
  return /* @__PURE__ */ React.createElement("div", { className: "express-checkout-ui" }, /* @__PURE__ */ React.createElement(CartSlider, null, /* @__PURE__ */ React.createElement(Cart, null)), /* @__PURE__ */ React.createElement(ShippingMethods, { shippingMethodsAsides }), isNearestPickup && /* @__PURE__ */ React.createElement(Alert, { variant: "info", className: "alert-m-default" }, getLabel("checkout.summary.shipment.nearestPickup.message")), /* @__PURE__ */ React.createElement(ExpressCheckoutFormContainer, null), /* @__PURE__ */ React.createElement(
    ServiceStoreHeading,
    {
      title: labels.expressServiceStoreTitle,
      subtitle: labels.expressServiceStoreSubtitle,
      shouldHideIcon: true
    }
  ), /* @__PURE__ */ React.createElement(ServiceStore, null), /* @__PURE__ */ React.createElement(Consents, null), /* @__PURE__ */ React.createElement(ImplicitTermsAndConditionsContainer, null));
};
export {
  ExpressCheckoutUI
};
//# sourceMappingURL=ExpressCheckoutUI.js.map
